import React from "react";
import { Box, Flex, Text, Icon, Divider, Stack } from "@chakra-ui/react";
import {
  BadgeCheck,
  BadgeInfo,
  BadgeX,
  Calendar,
  Bell,
  Users,
  Mailbox,
} from "lucide-react";
import ReusableAvatar from "components/Avatar/ReusableAvatar";

const getDisplayUsers = (notification) => {
  if (notification.targetUsers?.length > 0) {
    return notification.targetUsers
      .map((t) =>
        t === "Individual" ? "Individuals" : t + "s"
      )
      .join(", ");
  }
  return "All Users";
};

const ViewNotification = ({ notification }) => {
  if (!notification) return null;

  const displayUsers = getDisplayUsers(notification);

  return (
    <Flex direction="column" p={8} width="100%">
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center">
          <ReusableAvatar name={notification.notificationType} />
          <Box>
            <Text
              fontSize="2xl"
              fontWeight="bold"
              display="flex"
              alignItems="center"
            >
              {displayUsers}

              {notification.status === "Sent" && (
                <>
                  <Icon
                    as={BadgeCheck}
                    color="green.500"
                    stroke="white"
                    ml={1}
                    fill="green.500"
                  />
                  <Text color="green.500" fontSize="13px">
                    {" "}
                    Sent
                  </Text>
                </>
              )}

              {notification.status === "Pending" && (
                <>
                  <Icon
                    as={BadgeInfo}
                    color="yellow.500"
                    stroke="white"
                    ml={1}
                    fill="yellow.500"
                  />
                  <Text color="yellow.500" fontSize="13px">
                    {" "}
                    Pending
                  </Text>
                </>
              )}

              {notification.status === "Archived" && (
                <Icon
                  as={BadgeX}
                  color="red.500"
                  stroke="white"
                  ml={1}
                  fill="red.500"
                />
              )}
            </Text>

         
          </Box>
        </Flex>
      </Flex>

      <Flex mt={2} alignItems="center">
        <Icon as={Calendar} size={16} color="gray.500" mr={1} />
        <Text fontSize="sm" color="gray.500">
          {notification.sentAt}
        </Text>
      </Flex>

      <Divider my={6} />

      <Flex direction="column" p={4}>
        <Text fontSize="lg" fontWeight="bold" mb={2}>
          {notification.title}
        </Text>

        <Box mb={6}>
          <Stack spacing={4}>
            <Flex
              alignItems="center"
              border="1px"
              borderColor="gray.300"
              borderRadius="md"
              p={2}
            >
              <Icon as={Bell} mr={2} color="gray.400" />
              <Text fontWeight="500" color="gray.500" fontSize="sm">
                Notification Type: {notification.notificationType}
              </Text>
            </Flex>

            <Flex
              alignItems="center"
              border="1px"
              borderColor="gray.300"
              borderRadius="md"
              p={2}
            >
              <Icon as={Users} mr={2} color="gray.400" />
              <Text fontWeight="500" color="gray.500" fontSize="sm">
                Target Users: {displayUsers}
              </Text>
            </Flex>

            <Box
              border="1px"
              borderColor="gray.300"
              borderRadius="md"
              p={6}
              display="flex"
              alignItems="center"
            >
              <Icon as={Mailbox} mr={3} color="gray.400" fontSize="lg" />
              <Text fontWeight="500" color="gray.500" fontSize="md">
                Message: {notification.message}
              </Text>
            </Box>
          </Stack>
        </Box>
      </Flex>
    </Flex>
  );
};

export default ViewNotification;